<form [formGroup]='movingContent' (ngSubmit)='onSubmit()' id='{{formGroupName}}'>

	<div class='normal-moving-size'>

		<!-- Property rooms ON -->
		<ng-container *ngIf='formService.mainForm.controls["_propertyRoomsEnabled"].value'>

			<!-- Moving size 1 & 2 -->
			<ng-container *ngIf='getMovingSize() === 1 || getMovingSize() === 2'>
				<div class='step-title' i18n>Do you have any <span class='color-blue'>additional remarks?</span></div>
			</ng-container>

			<!-- Moving size 3 -->
			<!-- Same title as without property rooms -->
			<ng-container *ngIf='getMovingSize() === 3'>
				<div class='step-title' i18n>Describe <span class='color-blue'>what</span> you're moving.</div>
			</ng-container>

		</ng-container>

		<!-- Property rooms OFF -->
		<ng-container *ngIf='!formService.mainForm.controls["_propertyRoomsEnabled"].value'>
			<div class='step-title' i18n>Describe <span class='color-blue'>what</span> you're moving.</div>
		</ng-container>

		<div class='form-control'>

			<!-- Property rooms ON -->
			<ng-container *ngIf='formService.mainForm.controls["_propertyRoomsEnabled"].value'>

				<!-- Moving size 1 & 2 have the same placeholder -->
				<!-- Moving size 3 has the placeholder from without property rooms -->

				<!-- Moving size 1 & 2 -->
				<ng-container *ngIf='getMovingSize() === 1 || getMovingSize() === 2'>
					<mat-form-field appearances='standard'>
					<textarea formControlName='movingContent'
					          matInput
					          [tabIndex]='formService.verifyTabIndex( formGroupName )'
					          placeholder='ex. fragile items, vehicle transport, packing/assembly assistance'
					          i18n-placeholder='@@movingSizePlaceholder'></textarea>
					</mat-form-field>
				</ng-container>

				<!-- Moving size 3 -->
				<ng-container *ngIf='getMovingSize() === 3'>
					<mat-form-field appearances='standard'>
					<textarea formControlName='movingContent'
				          matInput
				          [tabIndex]='formService.verifyTabIndex( formGroupName )'
				          placeholder='E.g. 1 sofa and 3 boxes'
				          i18n-placeholder='@@movingSize3Placeholder'></textarea>
					</mat-form-field>
				</ng-container>

			</ng-container>

			<!-- Property rooms OFF -->
			<ng-container *ngIf='!formService.mainForm.controls["_propertyRoomsEnabled"].value'>
				<ng-container *ngIf='getMovingSize() === 1'>
					<mat-form-field appearances='standard'>
					<textarea formControlName='movingContent'
					          matInput
					          [tabIndex]='formService.verifyTabIndex( formGroupName )'
					          placeholder='E.g. contents of a 4-room household'
					          i18n-placeholder='@@movingSize1Placeholder'></textarea>
					</mat-form-field>
				</ng-container>
				<ng-container *ngIf='getMovingSize() === 2'>
					<mat-form-field appearances='standard'>
					<textarea formControlName='movingContent'
					          matInput
					          [tabIndex]='formService.verifyTabIndex( formGroupName )'
					          placeholder='E.g. 1 table, 4 chairs, 1 kingsize bed, 1 lamp and 10 boxes'
					          i18n-placeholder='@@movingSize2Placeholder'></textarea>
					</mat-form-field>
				</ng-container>
				<ng-container *ngIf='getMovingSize() === 3'>
					<mat-form-field appearances='standard'>
					<textarea formControlName='movingContent'
					          matInput
					          [tabIndex]='formService.verifyTabIndex( formGroupName )'
					          placeholder='E.g. 1 sofa and 3 boxes'
					          i18n-placeholder='@@movingSize3Placeholder'></textarea>
					</mat-form-field>
				</ng-container>
			</ng-container>
		</div>
		<div class='form-info-desktop'>
			<div class='info-left'>
				<ng-container *ngIf='!hasVolume()'>
					<div class='info-text'>
						<ng-container i18n>For more accurate quotes, calculate the volume here</ng-container>
					</div>
					<mat-icon svgIcon='icons:arrow-right'></mat-icon>
				</ng-container>
				<p *ngIf='hasVolume()'><ng-container i18n>Your volume has been saved and is determined to be</ng-container>&nbsp;<span>{{ getVolumeText() }}</span></p>
			</div>
			<div class='info-right'>
				<button type='button'
				        [tabIndex]='formService.verifyTabIndex( formGroupName )'
				        (click)='openVolumeCalculator()'>
					<div class='button-content'>
						<mat-icon svgIcon='icons:calculator'></mat-icon>
						<div class='button-text' *ngIf='!hasVolume()' i18n='@@buttonOpenVolumeCalculator'>Volume calculator</div>
						<div class='button-text' *ngIf='hasVolume()' i18n='@@buttonEditVolumeCalculator'>Edit volume</div>
					</div>
				</button>
			</div>
		</div>
		<div class='form-info-mobile'>
			<div class='mobile-info'>
				<div *ngIf='!hasVolume()' class='before'>
					<p><ng-container i18n='This is part 1 of a sentence@@movingContentMobilePart1'>For more accurate quotes,</ng-container>&nbsp;<a (click)='openVolumeCalculator()' i18n='This is part 2 of a sentence. This is clickable@@movingContentPart2'>calculate your volume here</a></p>
				</div>
				<div *ngIf='hasVolume()' class='after'>
					<p><ng-container i18n>Calculated volume:</ng-container>&nbsp;<span>{{ getVolumeText() }}</span></p>
					<a (click)='openVolumeCalculator()' i18n='@@buttonEditVolume'>Edit</a>
				</div>
			</div>
		</div>

	</div>

	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backMainForm()'>
				<mat-icon svgIcon='icons:chevron-left'></mat-icon>
				<ng-container i18n='@@buttonBack'>Back</ng-container>
			</button>
			<button class='submit'
			        type='submit'><ng-container i18n='@@buttonContinue'>Continue</ng-container>
				<mat-icon svgIcon='icons:chevron-right'></mat-icon>
			</button>
		</div>
	</div>

</form>